module.exports = __webpack_public_path__ + "img/logo.85c2c145.png";